import React from "react";
import { setShowSuccessModal } from "../../../../redux/pages/forgotPasswordPageSlice";
import { ForgotPasswordSuccessModal } from "./ForgotPasswordSuccessModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type ForgotPasswordContainerProps = React.ComponentProps<"div">;

export const ForgotPasswordContainer = ({
  children,
}: ForgotPasswordContainerProps) => {
  const dispatch = useDispatch();
  const forgotPasswordPageRedux = useSelector(
    (state: RootState) => state.forgotPasswordPage,
  );
  return (
    <>
      <ForgotPasswordSuccessModal
        open={forgotPasswordPageRedux.showSuccessModal}
        onClose={() => {
          dispatch(setShowSuccessModal(false));
        }}
      />
      <div
        className={
          "flex flex-col items-stretch justify-start px-2 lg:w-96 gap-10 mt-10 h-[41rem]"
        }
      >
        {children}
      </div>
    </>
  );
};
